import { languageBtnTextMapKey } from 'src/i18n';
import { store } from '..';

export const getLanguage = (): languageBtnTextMapKey => {
  return store.getState().settings.language;
};
